module.exports = __webpack_public_path__ + "img/gear-icon.c58704a9.svg";